import { useAppTranslation, useBackToShop } from "@/utils";
import { CloseCircleFilled, PhRArrowCounterClockwise } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

interface FailedProps {
  onRetry?: () => void;
  onRetryLoading?: boolean;
  message?: string;
}
const PayGetOrderIssuePromissoryFailed = ({ message, onRetry, onRetryLoading }: FailedProps) => {
  const { t } = useAppTranslation();

  const { backToShop, shopName } = useBackToShop();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center">
      <Flex vertical align="center" gap={"large"} className="tw:my-auto tw:w-full">
        <CloseCircleFilled width={80} className="tw:fill-color-error" />
        <Flex vertical gap={"small"} align="center" className="tw:mt-1!">
          <Typography.Title level={5} className="tw:m-0! tw:font-semibold!">
            {message || t("pay.getOrder.steps.issuePromissory.unAvailableContent")}
          </Typography.Title>
        </Flex>
        {onRetry ? (
          <Button
            type="link"
            icon={<PhRArrowCounterClockwise width={14} height={14} />}
            onClick={async () => {
              if (!onRetry) return;
              await onRetry();
            }}
            loading={onRetryLoading ?? false}
          >
            {t("common.retry")}
          </Button>
        ) : null}
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Button
          block
          onClick={() => {
            backToShop();
          }}
        >
          {t("common.returnTo", { name: shopName })}
        </Button>
      </Flex>
    </Flex>
  );
};

export default PayGetOrderIssuePromissoryFailed;
